namespace ui
{
	export namespace Form
	{
		export interface INumberInputDescriptor extends IBasicInputDescriptor
		{
			min?: number;
			max?: number;
			step?: number;
		}

		export class NumberInput
			extends Input<INumberInputDescriptor>
		{
			private isInt: boolean;

			public constructor( value: number|null, descriptor: INumberInputDescriptor, int: boolean = true )
			{
				super( 'input', descriptor, 'number', InputValueTypes.NUMBER );

				this.isInt = int;
				this.value( value );
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.min !== undefined )
				{
					this.attr( 'min', this.Descriptor.min );
				}
				if ( this.Descriptor.step )
				{
					this.attr( 'step', this.Descriptor.step );
				}
				if ( this.Descriptor.max !== undefined )
				{
					this.attr( 'max', this.Descriptor.max );
				}
			}

			public value( val: number|null ): NumberInput
			{
				this.m_Root.val( val === null ? '' : val );

				return this;
			}

			public val(): number | null
			{
				const val = this.m_Root.val() || '';

				return val === '' ? null : ( this.isInt ? parseInt( val as string, 10 ) : parseFloat( val as string ) );
			}

		}
	}
}
